<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import { useAgentInvitation } from 'dashboard/permissionSets/useAgentInvitation';
const emit = defineEmits(['close']);
const {
  agentName,
  agentEmail,
  selectedRoleId,
  v$,
  uiFlags,
  roles,
  selectedRole,
  rolesLoading,
  rolesError,
  load,
  addAgent,
} = useAgentInvitation(() => emit('close'));
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('AGENT_MGMT.ADD.TITLE')"
      :header-content="$t('AGENT_MGMT.ADD.DESC')"
    />
    <form class="flex flex-col items-start w-full" @submit.prevent="addAgent">
      <div class="w-full">
        <label :class="{ error: v$.agentName.$error }">
          {{ $t('AGENT_MGMT.ADD.FORM.NAME.LABEL') }}
          <input
            v-model="agentName"
            type="text"
            :placeholder="$t('AGENT_MGMT.ADD.FORM.NAME.PLACEHOLDER')"
            @input="v$.agentName.$touch"
          />
        </label>
      </div>

      <div class="w-full">
        <label :class="{ error: v$.selectedRoleId.$error }">
          {{ $t('AGENT_MGMT.ADD.FORM.AGENT_TYPE.LABEL') }}
          <select
            v-model="selectedRoleId"
            :disabled="rolesLoading || rolesError"
            @change="v$.selectedRoleId.$touch"
          >
            <option v-for="role in roles" :key="role.id" :value="role.id">
              {{ role.label }}
            </option>
          </select>
          <span v-if="v$.selectedRoleId.$error" class="message">
            {{ $t('AGENT_MGMT.ADD.FORM.AGENT_TYPE.ERROR') }}
          </span>
        </label>
      </div>

      <div class="w-full">
        <label :class="{ error: v$.agentEmail.$error }">
          {{ $t('AGENT_MGMT.ADD.FORM.EMAIL.LABEL') }}
          <input
            v-model="agentEmail"
            type="email"
            :placeholder="$t('AGENT_MGMT.ADD.FORM.EMAIL.PLACEHOLDER')"
            @input="v$.agentEmail.$touch"
          />
        </label>
      </div>

      <p v-if="rolesError" role="alert" class="text-n-ruby-11">
        {{ $t('PERMISSION_SETS.ASSIGNMENT.LOAD_ERROR') }}
      </p>
      <Button
        v-if="rolesError"
        type="button"
        :label="$t('PERMISSION_SETS.RETRY')"
        @click="load"
      />
      <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
        <Button
          faded
          slate
          type="reset"
          :label="$t('AGENT_MGMT.ADD.CANCEL_BUTTON_TEXT')"
          @click.prevent="emit('close')"
        />
        <Button
          type="submit"
          :label="$t('AGENT_MGMT.ADD.FORM.SUBMIT')"
          :disabled="
            v$.$invalid ||
            uiFlags.isCreating ||
            rolesLoading ||
            rolesError ||
            !selectedRole
          "
          :is-loading="uiFlags.isCreating"
        />
      </div>
    </form>
  </div>
</template>
